export default __webpack_public_path__ + "static/media/brain-out@2x.3735aba2.webp";